/* 曹操傳・第 5 章：宛城・典韋守門（建安二年，197）
 * 史實：張繡降而復叛，夜襲曹營。《武帝紀》：曹操「爲流矢所中，長子昂、弟子安民遇害」。
 *       《典韋傳》：「韋戰於門中，賊不得入」，「韋以長戟左右擊之，一叉入，輒十餘矛摧」，最後「韋前突賊，殺數人，創重發，瞋目大罵而死」。
 * 流程：操作典韋守營門。張繡的兵一波波從南面湧來，也會去砍東西兩側單薄的木柵（砍破了就能從那裡進營）。
 *       進了營的賊兵會去追曹操。撐到曹操從北面小門逃遠，典韋最後力戰而死（劇情）。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, troop } from '../kit.ts';
import { CAMP, GATE, WEAK, NORTH, EXIT } from '../maps/yushui.ts';

const LV = 8, ESCAPE_T = 70, END_T = 95, WEAK_HP = 900;
const ZX = troop('zhangxiu-soldier', '張繡兵', { armor: '#6a5a3a', sleeve: '#4a4030', cloth: '#4a4030', plume: '#a08050' });
const FOE = { spec: ZX, name: '張繡兵', hp: 360, maxHp: 360, atk: 22, ms: 240 };

export default {
  id: 'caocao-5', map: 'yushui', hero: 'dianwei',
  title: '第 5 章　宛城・典韋守門', year: '建安二年（197）',
  brief: {
    quote: [{ text: '韋戰於門中，賊不得入。', src: '《三國志·魏書·典韋傳》' }],
    text: '張繡投降後又反悔，夜裡突襲曹營。曹操措手不及，典韋獨自守在營門。',
    goals: ['守住營門，別讓賊兵進營', '撐到曹操從北面逃遠'],
  },
  words: { ally: '親兵', foe: '張繡兵' },
  stars: [
    { text: '賊不得入：沒有賊兵進到營裡', ok: (m) => !m.vars.breach },
    { text: '曹操毫髮無傷', ok: (m) => !m.vars.caoHit },
    { text: '一叉入，輒十餘矛摧：斬殺 40 人以上', ok: (m) => m.stats.slain >= 40 },
  ],
  steps: [
    { // 1. 守門
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = GATE[0]; me.y = GATE[1] - 60;
        V.t0 = w.t; V.foes = [];
        w.addBuff(me, { id: '死戰', t: 9999, atkP: 0.5, taken: -0.3 }); // 一叉入，輒十餘矛摧：典韋在門裡以一當十
        V.cao = ally(w, 'caocao', CAMP.x, CAMP.y - 200, LV); V.cao.hold = [CAMP.x, CAMP.y - 200]; V.caoHp = V.cao.hp;
        V.weak = WEAK.map(([x, y], k) => { m.gate('weak' + k, x, y, 170, 'abatis', null, { hp: WEAK_HP, hp0: WEAK_HP }); return { x, y, hp: WEAK_HP, broken: false }; });
        m.big('張繡反了！');
        m.card('韋戰於門中，賊不得入。', '《典韋傳》');
        m.after(2, () => m.line('典韋', '主公快走！有典韋在，誰也別想進這道門！'));
        m.after(6, () => m.line('提示', '賊兵也會砍東西兩側單薄的木柵；砍破了就能從那裡進營。進了營的賊兵會去追曹操。'));
        m.mark('cao', V.cao.x, V.cao.y, '曹操', true, V.cao);
        m.obj('hold', '');
        // 一波波湧來：大部分衝營門，一部分去砍兩側的木柵
        for (let k = 0; k < 8; k++) m.after(1 + k * 11, () => {
          for (let i = 0; i < 5 + Math.floor(k / 2); i++) {
            const side = i % 4 === 3 ? (k + i) % 2 : -1, u = m.foe('huangjin', GATE[0] - 300 + (i % 5) * 140, GATE[1] + 650 + Math.floor(i / 5) * 90, FOE);
            u.side = side; u.home = side < 0 ? [GATE[0] + (SG.rand() - 0.5) * 120, GATE[1] + 40] : [WEAK[side][0] + (side ? 130 : -130), WEAK[side][1]];
            V.foes.push(u);
          }
        });
      },
      tick(m, w, dt) {
        const V = m.vars, cao = V.cao, t = w.t - V.t0;
        // 兩側木柵：門外沒在打人的賊兵在砍
        V.weak.forEach((s, k) => {
          if (s.broken) return;
          const n = V.foes.filter((u) => u.alive && u.side === k && !(u.target && u.target.alive) && SG.gd(u.x, u.y, s.x, s.y) < 260).length;
          s.hp -= n * 12 * dt;
          const g = m.gates.find((x) => x.id === 'weak' + k); if (g) g.hp = Math.max(0, s.hp);
          if (s.hp <= 0) { s.broken = true; m.ungate('weak' + k); m.big(`${k ? '東' : '西'}側木柵被砍破了！`); }
        });
        // 進了營的賊兵：去追曹操
        for (const u of V.foes) if (u.alive && Math.abs(u.x - CAMP.x) < CAMP.hw - 40 && u.y < CAMP.y + CAMP.hh - 220) { if (!u.inside) { u.inside = true; V.breach = true; } if (!(u.target && u.target.alive)) u.home = [cao.x, cao.y]; }
        // 曹操：35 秒後從北門逃
        if (t > 20 && !V.run) { V.run = true; cao.hold = null; m.line('曹操', '典韋，撐住！'); }
        if (V.run && cao.alive) { cao.input.target = null; cao.input.moveTo = SG.gd(cao.x, cao.y, EXIT[0], EXIT[1]) > 60 ? EXIT.slice() : null; }
        const inside = V.foes.filter((u) => u.alive && u.inside).length;
        if (inside >= 6) { m.lose('賊兵大舉湧進營裡'); return false; }
        if (cao.hp < V.caoHp - 1) V.caoHit = true;
        V.caoHp = cao.hp;
        m.get('hold').text = `${t < ESCAPE_T ? `守住營門，等曹操逃遠（${Math.ceil(ESCAPE_T - t)} 秒）` : '曹操逃遠了……'}　營裡的賊兵 ${inside}/6`;
        return t >= ESCAPE_T;
      },
    },
    { // 2. 瞋目大罵而死
      enter(m, w) {
        const V = m.vars;
        m.done('hold'); m.unmark('cao');
        m.card('太祖乘馬遁去。', '《武帝紀》');
        m.after(3, () => m.line('典韋', '來啊！典韋在此！'));
        m.obj('last', '最後一戰');
        V.t1 = w.t;
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        if (w.t - V.t1 < END_T - ESCAPE_T && me.hp > me.maxHp * 0.08) return false;
        m.done('last');
        me.hp = 1; me.st.stun = 9;
        m.card('韋前突賊，殺數人，創重發，瞋目大罵而死。', '《典韋傳》');
        m.after(6, () => m.win());
        return true;
      },
    },
    { tick() { return false; } },
  ],
  always(m, w) {
    const V = m.vars;
    if (!V.cao) return;
    if (!V.cao.alive) { m.lose('曹操遇害'); return; }
    // 典韋：曹操還沒逃遠之前不能倒下；之後的倒下就是結局
    if (!w.player.alive) { if (m.i === 0) m.lose('典韋倒下，賊兵衝進了營門'); else if (!m.over) m.win(); }
  },
};
